<template>
  <el-container class="f-h" ref="">
    <el-aside v-if="meta.showHis" width="330px">
      <el-card shadow="never" style="height: 99%;overflow: auto">
        <div slot="header">
          <b>历史诊断：</b>
          <el-select size="mini" style="width: 80px" v-model="his.condition.scope" placeholder="全部" @change="queryHistory" clearable>
            <el-option value="住院">住院</el-option>
            <el-option value="门诊">门诊</el-option>
          </el-select>
          <el-select size="mini" style="width: 80px" v-model="his.condition.yearVal" placeholder="全部" @change="queryHistory" clearable class="left-pad">
            <el-option label="今年" :value="new Date().getFullYear()"></el-option>
            <el-option v-for="item in 5" :key="item" :label="new Date().getFullYear() - item" :value="new Date().getFullYear() - item"></el-option>
          </el-select>
        </div>
        <el-timeline v-if="his.items.length" class="left">
          <el-timeline-item v-for="(item, index) in his.items" :key="index" :timestamp="hisFooter(item)" :type="item.mainNo != entity.ipNo ? 'success' : 'primary'">
            <!-- <template slot="dot">
              <el-tag v-if="item.scope=='住院'" type="primary" effect="dark" size="mini">住</el-tag>
              <el-tag v-if="item.scope=='门诊'" type="warning" effect="dark" size="mini">门</el-tag>
            </template> -->
            <el-link v-if="item.mainNo != entity.ipNo" type="primary" @click="addRowFromHis(item)" :disabled="isEditing">{{ item.name }}</el-link>
            <span v-else>{{ item.name }}</span>
          </el-timeline-item>
        </el-timeline>
        <el-empty v-else description="暂无数据"></el-empty>
      </el-card>
    </el-aside>
    <el-main>
      <el-container class="f-h">
        <el-header class="sub-header">
          <el-row type="flex" justify="space-between">
            <el-col :span="14" class="sub-title" style="text-align: left">
              <el-button @click="meta.showHis = !meta.showHis" type="default" plain size="small" :icon="!meta.showHis ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left'" title="历史诊断"></el-button>
              <el-button @click="addRow" type="primary" size="small" icon="el-icon-document-add" :disabled="isEditing">新增</el-button>
            </el-col>
          </el-row>
        </el-header>
        <el-main v-loading="meta.loading" style="padding: 0px 10px">
          <el-table @sort-change="sortChange" @filter-change="filterChange" :data="entities.items" height="100%">
            <!-- <el-table-column  align="center" type="selection" width="55"></el-table-column> -->
            <el-table-column align="center" label="操作" width="100">
              <template slot-scope="{ row }">
                <template v-if="!row.isEditing">
                  <el-button @click="editRow(row)" type="primary" icon="el-icon-edit" circle plain size="mini" :disabled="isEditing"></el-button>
                  <el-button @click="delRow(row.id)" type="danger" icon="el-icon-delete" circle plain size="mini" :disabled="isEditing || row.ifPrimary"></el-button>
                </template>
                <template v-else>
                  <el-button @click="saveRow(row)" type="success" icon="el-icon-check" circle plain size="mini"></el-button>
                  <el-button @click="cancelRow(row)" type="danger" icon="el-icon-close" circle plain size="mini"></el-button>
                </template>
              </template>
            </el-table-column>

            <el-table-column :filter-multiple="false" :filters="dictEnum.DiagnosisKind" column-key="kind" align="center" label="类型" prop="kind" width="100">
              <template slot-scope="{ row }">
                <div v-if="row.isEditing">
                  <hic-dict-selector dict-type="DiagnosisKind" is-enum v-model="row.kind" />
                </div>
                <div v-else>{{ row.kind | dictText("DiagnosisKind") }}</div>
              </template>
            </el-table-column>
            <el-table-column :filter-multiple="false" :filters="dictEnum.DiagnosisType" column-key="type" align="center" label="分类" prop="type" width="100">
              <template slot-scope="{ row }">
                <div v-if="row.isEditing">
                  <hic-dict-selector dict-type="DiagnosisType" is-enum v-model="row.type" />
                </div>
                <div v-else>{{ row.type }}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="主诊断" prop="kind" width="100">
              <template slot-scope="{ row }">
                <el-button v-if="!row.ifPrimary" @click="setPrimary(row)" type="default" circle size="mini" plain icon="el-icon-check" :disabled="isEditing"></el-button>
                <el-tag v-else type="danger" effect="dark" size="small"><i class="el-icon-check" /></el-tag>
              </template>
            </el-table-column>
            <el-table-column align="left" label="诊断名称" prop="name" min-width="200">
              <template slot-scope="{ row }">
                <div v-if="row.isEditing">
                  <el-select :loading="meta.searchLoading" :popper-append-to-body="false" @change="setDisease(row)($event)" size="small" style="width: 100%" v-model="row.disease" filterable placeholder="请选择" remote :filter-method="queryDisease" value-key="name">
                    <el-option v-if="disease.items && disease.items.length" value=" " disabled>
                      <el-row style="width: 30rem; font-size: 15px" :gutter="16">
                        <el-col :span="20">诊断名称</el-col>
                        <el-col :span="4">疾病编码</el-col>
                      </el-row>
                    </el-option>
                    <el-option v-for="item in disease.items" :key="item.id" :label="item.name" :value="item" style="font-size: 15px">
                      <el-row style="width: 30rem; border-top: solid 1px #eee" :gutter="16">
                        <el-col :span="20">{{ item.name }}</el-col>
                        <el-col :span="4" style="white-space: break-spaces">{{ item.code }}</el-col>
                      </el-row>
                    </el-option>
                  </el-select>
                </div>
                <div v-else>{{ row.name }}</div>
              </template>
            </el-table-column>
            <el-table-column align="left" label="疾病编码" prop="code">
              <template slot-scope="{ row }">
                {{ row.code }}
              </template>
            </el-table-column>
            <el-table-column :filter-multiple="false" :filters="dictEnum.Condition" column-key="situation" align="left" label="病情" prop="situation" min-width="150">
              <template slot-scope="{ row }">
                <div v-if="row.isEditing">
                  <hic-dict-selector dict-type="Condition" is-enum v-model="row.situation" />
                </div>
                <div v-else>{{ row.situation }}</div>
              </template>
            </el-table-column>
            <!-- <el-table-column align="center" label="病理号" prop="pathologyNo"></el-table-column> -->
            <el-table-column :filter-multiple="false" :filters="dict.Dept" column-key="deptCode" align="center" width="150" label="科室" prop="standard">
              <template slot-scope="{ row }">
                {{ row.deptCode | dictText("Dept") }}
              </template>
            </el-table-column>
            <el-table-column align="center" width="100" label="医师" prop="doctorName">
              <template slot-scope="{ row }">
                {{ row.doctorName }}
              </template>
            </el-table-column>
            <el-table-column align="center" width="205" label="日期" prop="date">
              <template slot-scope="{ row }">
                <div v-if="row.isEditing">
                  <el-date-picker size="small" style="width: 100%" class="" v-model="row.date" type="datetime" placeholder="请选择开始时间"></el-date-picker>
                </div>
                <div v-else>{{ row.date | fmtDate }}</div>
              </template>
            </el-table-column>
          </el-table>
        </el-main>
      </el-container>
    </el-main>
  </el-container>
</template>
<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";

  export default {
    props: {
      entity: Object,
    },
    components: {},
    data() {
      return {
        meta: {
          searchLoading: false,
          loading: false,
          showHis: false,
          histroyLoading: false,
        },
        condition: {
          scope: "住院",
          mainNo: this.entity.ipNo,
          sort: "id",
          asc: false,
        },
        entities: {
          items: [],
        },
        his: {
          condition: {
            scope: "住院",
            yearVal: new Date().getFullYear(),
            sort: "id",
            asc: false,
          },
          items: [],
        },
        disease: {
          keyword: null,
          items: [],
        },
      };
    },
    computed: {
      ...mapGetters(["dict", "Enum", "dictEnum", "user", "permission"]),
      isEditing() {
        return this.entities.items.findIndex((i) => i.isEditing) >= 0;
      },
    },
    watch: {
      entity() {
        this.load();
      },
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        if (vm.entities.items.length == 0) {
          vm.load();
        }
      });
    },
    methods: {
      load() {
        this.his.condition.patientCode = this.entity.patientCode;
        this.condition.mainNo = this.entity.ipNo;
        this.queryEntitie();
        this.queryHistory();
      },
      queryEntitie() {
        this.meta.loading = true;
        api.Diagnosis.query(this.condition)
          .then((res) => {
            this.entities = res;
          })
          .catch((err) => {
            this.$message.error(err.message || err);
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      filterChange(obj) {
        let key = Object.keys(obj)[0];
        let value = obj[key][0];
        this.condition[key] = value;
        this.queryEntitie();
      },
      sortChange(obj) {
        this.condition.sort = obj.column.property;
        this.condition.asc = obj.column.order.indexOf("asc") > -1 ? true : false;
        this.$emit("refresh", this.condition);
      },
      addRow() {
        this.entities.items.unshift({
          isEditing: true,
          scope: "住院",
          mainNo: this.entity.ipNo,
          type: "西医",
          kind: "入院",
          ifPrimary: false,
          date: this.$utils.Dt.now(),
          patientCode: this.entity.patientCode,
          doctorCode: this.user.code,
          doctorName: this.user.name,
          deptCode: this.user.deptCode,
          level: 1,
        });
      },
      addRowFromHis(item) {
        this.addRow();
        let row = this.entities.items[0];
        row.code = item.code;
        row.name = item.name;
        row.situation = item.situation;
        this.editRow(row);
      },
      editRow(row) {
        row.origin = this.$utils.Obj.clone(row);
        this.$set(row, "disease", { code: row.code, name: row.name });
        this.disease.items = [row.disease];
        this.$set(row, "isEditing", true);
      },
      cancelRow(row) {
        if (row.id) {
          let origin = row.origin;
          delete row.origin;
          if (origin) {
            this.$utils.Obj.propertyCopy(origin, row);
            row.isEditing = false;
          }
        } else {
          this.entities.items.splice(this.entities.items.indexOf(row), 1);
        }
      },
      saveRow(row) {
        this.meta.loading = true;
        api.Diagnosis.save(row)
          .then((res) => {
            if (!row.id) {
              // this.setPrimary(res);
            }
            this.$message.success("已保存！");
            this.$utils.Obj.propertyCopy(res, row);
            row.isEditing = false;
          })
          .catch((err) => {
            this.$message.error(err.message || err);
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      delRow(id) {
        this.$confirm("确定要删除吗？", "警告", { type: "warning" })
          .then(() => {
            this.meta.loading = true;
            api.Diagnosis.del(id)
              .then((res) => {
                this.$message.success("已删除！");
                this.queryEntitie();
              })
              .catch((err) => {
                this.$message.error(err.message || err);
              })
              .finally(() => {
                this.meta.loading = false;
              });
          })
          .catch((e) => {});
      },
      queryHistory() {
        if (this.his.condition.yearVal) {
          this.his.condition.dateStart = this.his.condition.yearVal + "-01-01 00:00:00";
          this.his.condition.dateEnd = this.his.condition.yearVal + "-12-31 23:59:59";
        } else {
          this.his.condition.dateStart = null;
          this.his.condition.dateEnd = null;
        }

        this.meta.histroyLoading = true;
        api.Diagnosis.query(this.his.condition)
          .then((res) => {
            this.his.items = res.items;
          })
          .catch((err) => {
            this.$message.error(err.message || err);
          })
          .finally(() => {
            this.meta.histroyLoading = false;
          });
      },
      async queryDisease(keyword) {
        if (!keyword) return;

        this.meta.searchLoading = true;
        let res = await api.Disease.query({ keyword: keyword, pageSize: 10 });
        this.disease.items = res.items;

        this.meta.searchLoading = false;
      },
      setDisease(row) {
        return (disease) => {
          this.$set(row, "name", disease.name);
          this.$set(row, "code", disease.code);
        };
      },
      setPrimary(item) {
        this.meta.loading = true;
        api.Diagnosis.primary(item.id)
          .then((res) => {
            this.queryEntitie();
            this.entity.diagnosisCode = res.code;
            this.entity.diagnosisName = res.name;
            return api.Hospitalization.save(this.entity);
          })
          .then((res) => {
            this.entity.lockKey = res.lockKey;
          })
          .catch((err) => {
            this.$message.error(err.message || err);
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      hisFooter(item) {
        return `${this.$utils.Fmt.date(item.date)} ${item.doctorName} ${this.$utils.Dict.text(item.deptCode, "Dept")}`;
      },
    },
  };
</script>
